import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import scrollToTop from '../helpers/scrollToTop';
import emo from '../images/emo.png';
import bobi from '../images/bobi.png';
import ekip from '../images/team.jpg';
import mario from '../images/mario.png';
import sotir from '../images/sotir.jpg';
import georgi from '../images/georgi.png';

const TEAM_MEMBERS = {
  emo: {
    name: 'Емил',
    subheader: 'Основател и Мастър Бръснар',
    image: emo,
    desc: `Емил Алексиев винаги е бил човек, воден от страстта си към бръснарството. Още от 8-годишен, той вече знаеше, че иска да бъде бръснар. Първите му клиенти бяха неговите плюшени мечета, но това бързо се промени, когато станал на 13 години. Приятелите му му се довериха да експериментира върху техните прически и така страстта на Емил продължи да расте.

След малка пауза, на 18 години Емил реши да се захване сериозно с бръснарството. Работеше усилено като куриер, за да събере пари за професионален курс и така попадна при известния Асен Налбантов, който му помогна да усвои тънкостите на професията. С времето Емил стана още по-добър и натрупа опит в различни бръснарници, докато не събра достатъчно кураж и средства да отвори собствено място заедно с брат си - ALEXIEV’S BARBERSHOP.

Днес, Емил е горд собственик на своето бръснарско студио, където не само подстригва, но и вдъхновява младите да следват мечтите си. Той вярва, че всяка прическа има потенциала да промени не само външния вид на човек, но и неговата увереност. За Емил, ALEXIEV’S BARBERSHOP не е просто работа, а семейство, страст и начин на живот.`,
  },
  bobi: {
    name: 'Боян',
    subheader: 'Мастър Бръснар',
    image: bobi,
    desc: `Здравейте! Аз съм Боян Алексиев – професионален бръснар с над две години опит. Моят път в света на стила започна благодарение на брат ми, който ме запозна с първите и най-важни стъпки в този вълнуващ бранш. С течение на годините усъвършенствах техниките си и се стремя да съчетая традицията с модерните тенденции. За мен бръснарството не е просто занаят, а изкуство, в което вниманието към детайла и индивидуалният подход към всеки клиент са от първостепенно значение.

Добре дошли в моя свят, където страстта ми към перфекционизма и стремежът към отлично обслужване ме мотивират да се развивам непрестанно. Работата ми не се свежда само до подстригване – аз се старая да създам комфортна атмосфера, в която всеки клиент да се чувства специален и добре погрижен. Вярвам, че всеки заслужава индивидуално внимание и висококачествена грижа.`,
  },
  mario: {
    name: 'Марио',
    subheader: 'Бръснар',
    image: mario,
    desc: `Марио е бръснар с години опит на стола и с ясна философия: добрата прическа започва с внимателно изслушване на клиента. Владее до съвършенство класическото мъжко подстригване, всички видове фейд (low, mid, high и skin fade), както и прецизното оформяне на брада и кралското бръснене с гореща кърпа. Спокойният му и уверен подход печели клиенти, които се връщат при него години наред.

От 14 септември Марио ви очаква в новия ни салон Alexiev's Barbershop — La Barberia на бул. Черни връх 74, вх. А, София, от понеделник до събота, от 10:00 до 19:00 ч. Ако търсите мъжко подстригване, оформяне на брада или бръснене в района на Лозенец и бул. Черни връх, запазете своя час при Марио онлайн.`,
  },
  sotir: {
    name: 'Сотир',
    subheader: 'Бръснар',
    image: sotir,
    desc: `Сотир е бръснар с прецизна ръка и набито око за детайла, за когото всяка прическа е малко произведение на изкуството. Специалист е в модерното мъжко подстригване — от чисти класически визии до плавни фейд подстригвания (skin fade, mid fade, taper) — както и в оформянето на брада с гореща кърпа и класическо бръснене. Подхожда индивидуално към всеки клиент: изслушва, съветва и предлага визия, която пасва на стила и ежедневието ти.

Ще го откриете в Alexiev's Barbershop в кв. Слатина (ул. Слатинска, бл. 44А, София) — от понеделник до събота, от 10:00 до 19:00 ч. Ако търсите качествено мъжко подстригване, оформяне на брада или цялостна промяна на визията в София, запазете своя час при Сотир онлайн — ще излезете от салона с безупречна визия и добро настроение.`,
  },
  georgi: {
    name: 'Георги',
    subheader: 'Бръснар',
    image: georgi,
    desc: `Георги е бръснар, който съчетава младежка енергия с професионална техника и внимание към всеки детайл. Неговата страст са модерните мъжки прически — фейд подстригвания, текстурирани върхове и класически стилове — както и прецизното оформяне на брада и вежди. За Георги най-важното е клиентът да се чувства спокойно на стола и уверено, когато се погледне в огледалото.

Работи в Alexiev's Barbershop в кв. Слатина (ул. Слатинска, бл. 44А, София) в делнични дни от 14:30 до 19:00 ч., а в събота и неделя — цял ден от 10:00 до 19:00 ч. (почивен ден: вторник). Идеалният избор за следобеден час след работа или за спокойно подстригване през уикенда. Запазете час при Георги онлайн и се доверете на новото поколение бръснари на Alexiev's Barbershop.`,
  },
};

function TeamMember() {
  const { id } = useParams();
  const [member, setMember] = useState(TEAM_MEMBERS[id] || TEAM_MEMBERS.emo);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    setMember(TEAM_MEMBERS[id] || TEAM_MEMBERS.emo);
  }, [id]);

  return (
    <div className="min-h-screen">
      <div className="relative">
        <img
          className="brightness-75 grayscale object-cover h-[40vh] object-left-bottom w-full"
          src={ekip}
          alt="Фон със снимка на екипа"
        />
        <h2 className="absolute h-full top-0 flex items-center left-1/2 -translate-x-1/2 text-center py-4 text-5xl sm:text-6xl text-red-800">
          {member?.subheader || 'Мастър Бръснар'}
        </h2>
      </div>
      <section className="py-20 gap-4 flex justify-center relative text-neutral-950">
        <div className="flex flex-col gap-4 px-4">
          <p className="text-4xl">{member?.name}</p>
          <p>{member?.subheader}</p>
          <p className="max-w-lg mx-auto text-xl whitespace-pre-line">{member?.desc}</p>
        </div>
        {member?.image && (
          <img
            src={member.image}
            alt={`Снимка на ${member.name}`}
            className="w-1/4 h-fit grayscale object-cover hidden md:block"
          />
        )}
      </section>
    </div>
  );
}

export default TeamMember;
